export enum PriceKey {
  NATIVE = "price",
  PAIR = "pair",
  ORACLE = "oracle",
  PRE = "pre",
  END = "end",
  EXTERNAL = "external",
}

export enum BalanceKey {
  NATIVE = "balance",
  TOKEN = "token",
  EXTERNAL = "external",
}

export enum StakingKey {
  LPSTAKABLE = "lpStakable",
  LPSTAKED = "lpStaked",
  SLPSTAKED = "slpStaked",
  LPREWARD = "reward",
  SLPREWARD = "slpReward",
}

export enum AssetInfoKey {
  MINCOLLATERALRATIO = "minCollateralRatio",
  MULTIPLIER = "multiplier",
}
